<div class="page-layout simple fullwidth">
    <div class="header accent" fxLayout="column" fxLayoutAlign="center center">
        Quản lý Affiliate
    </div>

    <div class="action-button-container" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <div>
            <button mat-raised-button color="accent"  (click)="createAffiliate()">
                Tạo Code
            </button>
        </div>
        <div>
            <button mat-raised-button color="accent" (click)="exportCsv()">
                Xuất ra Excel
            </button>
        </div>
    </div>

    <div class="content p-16">
        <ag-grid-angular class="ag-theme-alpine" style="height: 100%" [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef" [rowData]="rowData" [enableCellTextSelection]="true" [animateRows]="true"
            (gridReady)="onGridReady($event)" (bodyScrollEnd)="onScrollEnd($event)" (firstDataRendered)="onLoaded()"
            (rowClicked)='rowClicked($event)'></ag-grid-angular>
    </div>
</div>